import { render, staticRenderFns } from "./WhatYouGetView.vue?vue&type=template&id=09d37b87&"
import script from "./WhatYouGetView.vue?vue&type=script&lang=js&"
export * from "./WhatYouGetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports